import CustomHeader from "../components/CustomHeader";
import HomeLanding from "../sections/HomeLanding";
import FeatureList from "../components/FeatureList";
import ImageGrid from "../components/ImageGrid";
import HomeShowcase from "../sections/HomeShowcase";
import FaqSection from "../components/FaqSection";
import Contact from "../sections/Contact";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <CustomHeader></CustomHeader>
      <HomeLanding></HomeLanding>

      <FeatureList />

      <ImageGrid />

      <HomeShowcase />

      <img alt="decoration" className="w-100" src="assets/shape.svg" />

      <FaqSection />

      <img alt="decoration" className="w-100" src="assets/shape-2.svg" />

      <Contact />

      <Footer />
    </>
  );
}

export default Home;
